export default __webpack_public_path__ + "static/media/048-repair services.c4b8e94a.svg";